import { render, staticRenderFns } from "./ConfirmOrderMismatches.vue?vue&type=template&id=03d4a2e7&"
import script from "./ConfirmOrderMismatches.vue?vue&type=script&lang=js&"
export * from "./ConfirmOrderMismatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports